export function Step2Vehicles({ formData, updateFormData, t }) {
    const handleVehicleChange = (index, field, value) => {
        const updatedVehicles = [...formData.vehicles];
        updatedVehicles[index][field] = value;

        // Logica condizionale per la lunghezza
        if (field === "vehicleType") {
            if (value === "bike" || value === "moto") {
                updatedVehicles[index].vehicleLength = "bike_moto";
            } else if (updatedVehicles[index].vehicleLength === "bike_moto") {
                // Se l'utente cambia da bike_moto, resetta la lunghezza
                updatedVehicles[index].vehicleLength = "";
            }
        }

        updateFormData({ vehicles: updatedVehicles });
    };

    const addVehicle = () => {
        const updatedVehicles = [...formData.vehicles, { vehicleType: "", vehicleLength: "", services: "" }];
        updateFormData({ vehicles: updatedVehicles });
    };

    const removeVehicle = (index) => {
        const updatedVehicles = formData.vehicles.filter((_, i) => i !== index);
        updateFormData({ vehicles: updatedVehicles });
    };

    return (
        <div className="step-content">
            <h3 className="mb-3">{t("stepper.step2.title")}</h3>
            {formData.vehicles.map((vehicle, index) => (
                <div key={index} className="vehicle-row mb-4">
                    <div className="row mt-1">
                        {/* Input per il Tipo di Veicolo */}
                        <div className="col-md-6 form-group">
                            <label className="form__label">{t("stepper.vehicle_type.label")} *</label>
                            <select
                                className="select-form-group form-control"
                                value={vehicle.vehicleType}
                                onChange={(e) => handleVehicleChange(index, "vehicleType", e.target.value)}
                                required
                            >
                                <option value="" hidden>
                                    {t("stepper.vehicle_type.placeholder")}
                                </option>
                                <option value="bike">{t("stepper.vehicle_type.options.bike")}</option>
                                <option value="moto">{t("stepper.vehicle_type.options.moto")}</option>
                                <option value="car">{t("stepper.vehicle_type.options.car")}</option>
                                <option value="trailer">{t("stepper.vehicle_type.options.trailer")}</option>
                                <option value="car_trailer">{t("stepper.vehicle_type.options.car_trailer")}</option>
                                <option value="minivan">{t("stepper.vehicle_type.options.minivan")}</option>
                                <option value="suv">{t("stepper.vehicle_type.options.suv")}</option>
                                <option value="cargovan">{t("stepper.vehicle_type.options.cargovan")}</option>
                                <option value="camper">{t("stepper.vehicle_type.options.camper")}</option>
                                <option value="truck">{t("stepper.vehicle_type.options.truck")}</option>
                                <option value="yacht">{t("stepper.vehicle_type.options.yacht")}</option>
                            </select>
                        </div>

                        {/* Input per la Lunghezza Veicolo - VISIBILE CONDIZIONALMENTE */}
                        {vehicle.vehicleType !== "bike" && vehicle.vehicleType !== "moto" && (
                            <div className="col-md-6 form-group mt-1 mt-md-0">
                                <label className="form__label d-flex align-items-center">
                                    {t("stepper.vehicle_length.label")} *
                                </label>
                                <select
                                    className="select-form-group form-control"
                                    value={vehicle.vehicleLength}
                                    onChange={(e) => handleVehicleChange(index, "vehicleLength", e.target.value)}
                                    required
                                >
                                    <option value="" hidden>
                                        {t("stepper.vehicle_length.placeholder")}
                                    </option>
                                    <option value="<5m">{t("stepper.vehicle_length.options.under_5m")}</option>
                                    <option value="5-7m">{t("stepper.vehicle_length.options.5_7m")}</option>
                                    <option value="7-10m">{t("stepper.vehicle_length.options.7_10m")}</option>
                                    <option value=">10m">{t("stepper.vehicle_length.options.over_10m")}</option>
                                </select>
                            </div>
                        )}
                    </div>

                    {/* Input per i Servizi Aggiuntivi */}
                    <div className="row mt-1">
                        <div className="col-12 form-group mb-0">
                            <label className="form__label">{t("stepper.additional_services.label")}</label>
                            <select
                                className="select-form-group form-control"
                                value={vehicle.services}
                                onChange={(e) => handleVehicleChange(index, "services", e.target.value)}
                            >
                                <option value="" hidden>
                                    {t("stepper.additional_services.placeholder")}
                                </option>
                                <option value="None">{t("stepper.additional_services.none")}</option>
                                <option value="vehicle_wash">{t("stepper.additional_services.vehicle_wash")}</option>
                                <option value="mechanic_assistance">
                                    {t("stepper.additional_services.mechanic_assistance")}
                                </option>
                                <option value="vehicle_wash_plus_mechanic_assistance">
                                    {t("stepper.additional_services.vehicle_wash_plus_mechanic_assistance")}
                                </option>
                            </select>
                        </div>
                    </div>

                    {formData.vehicles.length > 1 && (
                        <div className="text-end">
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => removeVehicle(index)}
                            >
                                {t("stepper.removeVehicle")}
                            </button>
                        </div>
                    )}
                </div>
            ))}
            <div className="row mt-3">
                <div className="col-12 text-center">
                    <button type="button" className="btn btn-outline-success" onClick={addVehicle}>
                        {t("stepper.addVehicle")}
                    </button>
                </div>
            </div>
        </div>
    );
}
